<div id="{{ mapName }}" class="rs-map"></div>
